import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function ContentSecuritySettingsPage() {
  return (
    <SettingsPlaceholder
      title="Content Security"
      description="Share-link passphrase requirements, allowed email domains, default access type. Deferred to Phase 2 (enterprise-tier feature)."
    />
  );
}
